import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getStatsOverview = api(async function getStatsOverview() {
    return query(
        gql`
            query getStatsOverview {
                getStatsOverview
            }
        `,
        {},
        { returns: "getStatsOverview" }
    )
})
